import React from 'react';

import CoproCompanyValidation from '../../components/Admin/CoproCompanyValidation';

function CoproCompanyValidationView() {
  return (
    <CoproCompanyValidation />
  );
}

export default CoproCompanyValidationView;
